import { render, staticRenderFns } from "./CustomersSelectCustomersBase.vue?vue&type=template&id=07c75365&scoped=true&"
import script from "./CustomersSelectCustomersBase.vue?vue&type=script&lang=js&"
export * from "./CustomersSelectCustomersBase.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSelectCustomersBase.vue?vue&type=style&index=0&id=07c75365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c75365",
  null
  
)

export default component.exports